import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router} from "react-router-dom"
import App from 'App'
import 'react-datepicker/dist/react-datepicker.css'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import './scss/global.scss'


ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById('root')
)
